export const CLIENT_ACTION_FETCH_RESOURCE_FAILURE = 'CLIENT_ACTION_FETCH_RESOURCE_FAILURE';

export function fetchResourceFailure(error: any) {
  return {
    type: CLIENT_ACTION_FETCH_RESOURCE_FAILURE,
    error: error,
  };
}
